import React, {useState, useEffect} from 'react';
import clsx from 'clsx';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Typography, Grid } from "@material-ui/core";
import { useDispatch } from "react-redux";
import SvgIcon from '@material-ui/core/SvgIcon';
import { DrawerProps } from '@material-ui/core/Drawer';
import { Link } from "react-router-dom";
import { Omit } from '@material-ui/types';

import { categories } from './listItems';
import "./../../../css/styles.css"

const styles = (theme: Theme) =>
  createStyles({
    item: {
      paddingTop: 1,
      paddingBottom: 1,
      color: 'rgba(255, 255, 255, 0.7)',
      '&:hover,&:focus': {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
      },
    },
    itemCategory: {
      backgroundColor: '#232f3e',
      boxShadow: '0 -1px 0 #404854 inset',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    firebase: {
      fontSize: 20,
      color: theme.palette.common.white,
      borderBottom: "1px solid rgba(255,255,255,0.2)",
      padding: theme.spacing(2),
      display: "block",
    },
    productName: {
      fontSize: "1em",
      fontWeight: 800,
    },
    itemActiveItem: {
      color: '#4fc3f7',
    },
    itemPrimary: {
      fontSize: 'inherit',
    },
    itemIcon: {
      minWidth: 'auto',
      marginRight: theme.spacing(2),
    },
  });

export interface NavbarProps extends Omit<DrawerProps, 'classes'>, WithStyles<typeof styles> {}

const HomeIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </SvgIcon>
  );
}

const Navbar = (props: NavbarProps) => {
  const { classes, ...other } = props;
  const dispatch = useDispatch();

  const logout = () => {
      dispatch({
    type: 'LOGOUT',
  })
      console.log("Navbar logout")
  }
  return (
    <Drawer variant="permanent" {...other}>
      <List>
      <ListItem className={classes.firebase}>
      {/* clsx(classes.firebase, classes.itemCategory) */}
          <Typography className={classes.productName}>
            Betastore
          </Typography>
        </ListItem>
        {categories.map((category, id) => (
          <React.Fragment key={id}>
            <ListItem
              key={category.id}
              button
              className={clsx(classes.item, category.active && classes.itemActiveItem)}
              onClick={() => {
                if (category.id === 'Logout') {
                  logout()
                }
              }}>
              <Link to={category.link} className="linkStyle">
              <ListItemIcon className={classes.itemIcon}>{category.icon}</ListItemIcon>
                <ListItemText
                  classes={{
                    primary: classes.itemPrimary,
                  }}
                >
                  {category.id}
                </ListItemText>
              </Link>
            </ListItem>
          </React.Fragment>
        ))}
      </List>
    </Drawer>
  );
};

export default withStyles(styles)(Navbar);

